export const PROSPECT_LEAD_DEVICE_TYPES = {
    MWEB: "Mweb",
    DESKTOP: "Desktop"
};

export const REASON_NOT_LISTED = "MY_REASON_IS_NOT_LISTED";

export const VAS_BANNERS = {
    CHALLAN: "Challan",
    CHALLAN_COUNT: "ChallanWithVariable",
    SERVICE_HISTORY: "ServiceHistory"
};

export const VAS_BOTTOM_SHEETS = {
    SERVICE_HISTORY: "SERVICE_HISTORY_BOTTOMSHEET",
    PDI: "PDI_BOTTOMSHEET"
};

export const DISPLAY_TYPES = {
    TYPE_A: "TYPE_A",
    TYPE_B: "TYPE_B"
};

export const VAS_CROSS_SELL_VARIANT_MAPPING = {
    [VAS_BANNERS.CHALLAN]: DISPLAY_TYPES.TYPE_B,
    [VAS_BANNERS.CHALLAN_COUNT]: DISPLAY_TYPES.TYPE_B,
    [VAS_BANNERS.SERVICE_HISTORY]: DISPLAY_TYPES.TYPE_A,
    [VAS_BOTTOM_SHEETS.SERVICE_HISTORY]: DISPLAY_TYPES.TYPE_A,
    [VAS_BOTTOM_SHEETS.PDI]: DISPLAY_TYPES.TYPE_B
};

export const EVENT_ACTION_MAPPING = {
    [VAS_BANNERS.CHALLAN]: "challan_cross_sell_clicked",
    [VAS_BANNERS.CHALLAN_COUNT]: "challan_cross_sell_clicked",
    [VAS_BANNERS.SERVICE_HISTORY]: "service_history_cross_sell_clicked",
    [VAS_BOTTOM_SHEETS.SERVICE_HISTORY]: "service_history_cross_sell_clicked",
    [VAS_BOTTOM_SHEETS.PDI]: "pdi_cross_sell_clicked"
};

export const CHR_REPORT_TYPES = {
    CAR_HEALTH_REPORT_IN_APP: "car_health_report_in_app"
};
